import styles from './styles.module.scss';
import { useTheme } from '@mui/material';

interface LoadingProps {
  fullScreem: boolean;
  noBackground: boolean;
}

const DivRing = ({ color }: { color: string }) => (
  <div
    style={{
      border: `8px solid ${color}`,
      borderColor: `${color} transparent transparent transparent`,
    }}
  />
);

const Loading = ({ fullScreem = false, noBackground = false }: LoadingProps) => {
  const theme = useTheme();
  return (
    <div
      className={`${styles.loader} ${fullScreem ? styles.loader_full_screem : ''} ${
        noBackground ? styles.loader_no_background : ''
      }`}
    >
      <div className={`${styles.lds_ring} ${fullScreem ? styles.lds_ring_full_screem : ''}`}>
        <DivRing color={theme.palette.primary.main} />
        <DivRing color={theme.palette.primary.main} />
        <DivRing color={theme.palette.primary.main} />
        <DivRing color={theme.palette.primary.main} />
      </div>
    </div>
  );
};

export default Loading;
